//@ts-nocheck
import React from 'react'
import { ConfigProvider, Input } from 'antd'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import scriptLoader from 'react-async-script-loader'
import MapMarkerCurrent from '../../../assets/MapMarkerCurrent.svg'
import MapMarkerPin from '../../../assets/MapMarkerPin.svg'
import MyLocation from '../../../assets/MyLocation.svg'
import MapSuggestionIcon from '../../../assets/MapSuggestionIcon.svg'
import Target from '../../../assets/Target.svg'
import Add from '../../../assets/Add.svg'
import Minus from '../../../assets/Minus.svg'
import GoogleMapReact from 'google-map-react'
import MapPopup from './MapNotiyPopup'
import ReactDOMServer from 'react-dom/server'
import { GlobalContext } from '../../../context/GlobalContext'
import './Map.scss'

var marker: any
var markerIcon: any = MapMarkerPin
var infowindow: any
const win: any = window
const googleMapApiKey = 'AIzaSyDtKbJ8frTCqg4LsSfO0GDPla_tmaO5Pmg'

// prettier-ignore
interface Props {
  handleSearch: any;
  handleAddress: any;
  placeholder: string;
  rtl: boolean;
  googleMapKey: string;
}

class Map extends React.Component<Props, any> {
  static defaultProps = {
    center: { lat: 24.7135517, lng: 46.6752957 },
    zoom: 11,
  }

  static contextType = GlobalContext;

  state = {
    mapApiLoaded: false,
    mapInstance: null,
    mapApi: null,
    geoCoder: null,
    places: [],
    center: this.props.center,
    zoom: this.props.zoom,
    address: this.props.address,
    draggable: true,
    lat: this.props.center.lat,
    lng: this.props.center.lng,
  }

  handleClickElement = ({ x, y, lat, lng, event }: any) => {
    this.setState({
      lat: lat,
      lng: lng,
    })
    markerIcon = MapMarkerPin
    if (infowindow) {
      infowindow.close()
    }
    if (this.props.onInfoWindowClose) {
      this.props.onInfoWindowClose()
    }
    this.setCurrentLocation(true)
  }

  apiHasLoaded = (map: any, maps: any) => {
    const { address } = this.state
    const geocoder = new maps.Geocoder()
    
    geocoder.geocode({ address: address }, (res, status) => {
      if (status === 'OK') {
        // this code for converting address to latLng
        const loc = res[0].geometry.location
        const center = { lat: loc.lat(), lng: loc.lng() }
        this.setState({
          lat: loc.lat(),
          lng: loc.lng(),
          center: center,
        })
        //updating converted latLng inside map with marker
        this.setCurrentLocation(true) //false is for current location
      }
    })

    this.setState({
      mapApiLoaded: true,
      mapInstance: map,
      mapApi: maps,
    })
    this.addMyLocationButton()
    this.customZoomInControl(map)
    this.setMapsLoaded()
  }

  setMapsLoaded() {
    const [state, dispatch] = this.context
    const { mapApiLoaded } = this.state
    dispatch({ type: 'MAP_LOAD_SUCCESS', payload: { googleMapsLoaded:  mapApiLoaded} })
  }
  
  addMyLocationButton() {
    let controlDiv = document.createElement('div')
    controlDiv.className = 'map-currentlocation'

    let firstChild = document.createElement('button')
    firstChild.style.backgroundColor = '#008CFF'
    firstChild.style.border = 'none'
    firstChild.style.outline = 'none'
    firstChild.style.width = '40px'
    firstChild.style.height = '40px'
    firstChild.style.borderRadius = '2px'
    firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)'
    firstChild.style.cursor = 'pointer'
    firstChild.style.marginRight = '10px'
    firstChild.style.padding = '0px'
    firstChild.title = 'Your Location'

    let secondChild = document.createElement('div')
    secondChild.style.margin = '10px'
    secondChild.style.width = '18px'
    secondChild.style.height = '18px'
    secondChild.style.backgroundImage = `url(${Target})`
    secondChild.style.backgroundSize = '18px 18px'
    secondChild.style.backgroundPosition = '0px 0px'
    secondChild.style.backgroundRepeat = 'no-repeat'

    secondChild.id = 'you_location_img'
    controlDiv.appendChild(firstChild)

    firstChild.appendChild(secondChild)
    this.state.mapInstance.controls[this.state.mapApi.ControlPosition.RIGHT_BOTTOM].push(controlDiv)

    firstChild.addEventListener('click', e => {
      this.handleCurrentLocationClick(e)
    })
  }

  customZoomInControl(map) {
    // Set CSS for the control border
    let controlDiv = document.createElement('div')
    controlDiv.className = 'map-zoomcontrol'

    var controlUI = document.createElement('div')
    controlUI.style.backgroundColor = '#008CFF'
    controlUI.style.border = '2px solid #008CFF'
    controlUI.style.border = 'none'
    controlUI.style.outline = 'none'
    controlUI.style.width = '40px'
    controlUI.style.height = '40px'
    controlUI.style.borderTopRightRadius = '2px'
    controlUI.style.borderTopLeftRadius = '2px'
    controlUI.style.cursor = 'pointer'
    //controlUI.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";

    // Set CSS for the control interior
    var controlText = document.createElement('div')
    controlText.style.width = '40px'
    controlText.style.height = '40px'
    controlText.style.backgroundImage = `url(${Add})`
    controlText.style.backgroundSize = '18px 18px'
    controlText.style.backgroundPosition = '11px 11px'
    controlText.style.backgroundRepeat = 'no-repeat'
    controlUI.appendChild(controlText)

    // Set CSS for the control border
    var controlUILeft = document.createElement('div')
    controlUILeft.style.backgroundColor = '#008CFF'
    controlUILeft.style.border = 'none'
    controlUILeft.style.outline = 'none'
    controlUILeft.style.cursor = 'pointer'
    controlUILeft.style.textAlign = 'center'
    controlUILeft.style.borderBottomRightRadius = '2px'
    controlUILeft.style.borderBottomLeftRadius = '2px'
    controlUILeft.style.width = '40px'
    controlUILeft.style.height = '41px'

    // Set CSS for the control interior
    var controlTextLeft = document.createElement('div')
    controlTextLeft.style.backgroundImage = `url(${Minus})`
    controlTextLeft.style.width = '40px'
    controlTextLeft.style.height = '40px'
    controlTextLeft.style.backgroundSize = '18px 18px'
    controlTextLeft.style.backgroundPosition = '11px 11px'
    controlTextLeft.style.backgroundRepeat = 'no-repeat'
    controlUILeft.appendChild(controlTextLeft)

    controlDiv.appendChild(controlUI)
    controlDiv.appendChild(controlUILeft)

    // Setup the click event listeners
    this.state.mapInstance.controls[this.state.mapApi.ControlPosition.RIGHT_BOTTOM].push(controlDiv)

    controlUI.addEventListener('click', () => {
      map.setZoom(map.getZoom() + 1)
    })

    // Setup the click event listeners
    controlUILeft.addEventListener('click', () => {
      map.setZoom(map.getZoom() - 1)
    })
  }

  handleCurrentLocationClick = (e: any) => {
    e.preventDefault()
    markerIcon = MapMarkerCurrent
    if (infowindow) {
      infowindow.close()
    }
    if (this.props.onInfoWindowClose) {
      this.props.onInfoWindowClose()
    }
    this.setCurrentLocation(false)
  }

  setCurrentLocation(isCordProvided: Boolean) {
    const { mapApi } = this.state

    navigator.geolocation.getCurrentPosition(
      position => {
        if (
          position.coords.latitude !== null &&
          position.coords.longitude !== null &&
          mapApi !== null
        ) {
          if (!isCordProvided) {
            this.setState({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            })
          }

          const geocoder = new mapApi.Geocoder()
          geocoder.geocode(
            {
              location: {
                lat: parseFloat(this.state.lat),
                lng: parseFloat(this.state.lng),
              },
            },
            (results: any, status: any) => {
              const myLatlng = {
                lat: this.state.lat,
                lng: this.state.lng,
              }

              if (this.state.mapInstance) {
                this.state.mapInstance.setCenter(myLatlng)
                this.state.mapInstance.setZoom(16)

                if (marker) {
                  marker.setMap(null)
                }

                marker = new mapApi.Marker({
                  position: myLatlng,
                  icon: markerIcon,
                })

                if (!infowindow) {
                  infowindow = new mapApi.InfoWindow({
                    content: '',
                    width: 200,
                  })

                  infowindow.addListener('closeclick', () => {
                    this.props.onInfoWindowClose()
                  })
                }

                marker.addListener('mouseover', () => {
                  if (!this.props.isOutOfCoverage) {
                    const mapPopup = ReactDOMServer.renderToString(
                      <MapPopup address={results[0].formatted_address} outOfDelivery={false} />
                    )

                    infowindow.setContent(mapPopup)

                    infowindow.open({
                      anchor: marker,
                      map: mapApi,
                      shouldFocus: false,
                    })
                  }
                })

                marker.setMap(this.state.mapInstance)
              }

              if (status === 'OK') {
                if (results[0]) {
                  this.handleAddressChange(results[0].formatted_address, myLatlng)
                }
              } else {
                console.log('Geocoder failed due to: ' + status)
              }
            }
          )
        }
      },
      function (error) {
        console.log('Unable to get the coordinates')
        console.log(error)
      }
    )
  }

  handleAddressChange = (value: any, ltLg: any) => {
    this.setState({
      address: value,
    })
    this.props.handleAddress(value, ltLg)
  }

  handleSelect = async (value: any) => {
    const results = await geocodeByAddress(value)
    const latLng = await getLatLng(results[0])

    this.handleAddressChange(value, latLng)
    this.setState({
      center: {
        lat: latLng.lat,
        lng: latLng.lng,
      },
      lat: latLng.lat,
      lng: latLng.lng,
      address: value,
    })
    markerIcon = MapMarkerPin
    this.state.mapInstance.setZoom(18)
    this.props.handleAddress(value, latLng)
    this.setCurrentLocation(true)
  }

  render() {
    const {
      rtl,
      placeholder,
      headingleft,
      labelleft,
      mapValue,
      isScriptLoaded,
      isScriptLoadSucceed,
      googleMapKey,
      isMapScriptLoaded,
    } = this.props

    const defaultMapOptions = {
      zoomControl: false,
      fullscreenControl: false,
    }

    if (this.props.isOutOfCoverage) {
      if (infowindow) {
        infowindow.close()
      }

      const mapPopup = ReactDOMServer.renderToString(<MapPopup outOfDelivery={true} />)

      infowindow.setContent(mapPopup)
      infowindow.open({
        anchor: marker,
        map: this.state.mapApi,
        shouldFocus: false,
      })
    }

    if (isScriptLoaded && isScriptLoadSucceed) {
      return (
        <>
          <PlacesAutocomplete
            value={this.state.address}
            onSelect={this.handleSelect}
            onChange={this.handleAddressChange}
            searchOptions={{ componentRestrictions: { country: ['sa'] } }}
          >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
              <>
                <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
                  <div className="map__inputField">
                    <div className={false ? 'heading-section floatRtl' : 'heading-section'}>
                      <div className="heading-left">{headingleft}</div>
                      <div className="heading-right">{}</div>
                    </div>
                    <div className="inputSection__withIcon">
                      <Input
                        className={
                          rtl ? 'input-section mapInput-right' : 'input-section mapInput-left'
                        }
                        value={mapValue}
                        {...getInputProps({
                          placeholder: placeholder,
                        })}
                      />
                      <img
                        src={MyLocation}
                        className={rtl ? 'locate-icon-rtl' : 'locate-icon-ltr'}
                        alt="icon"
                        onClick={e => this.handleCurrentLocationClick(e)}
                      />
                    </div>
                  </div>
                </ConfigProvider>
                <div className="map__suggestion">
                  {loading && <div>Loading...</div>}
                  {suggestions.map((suggestion, index) => {
                    const style = {
                      backgroundColor: suggestion.active ? '#C3CED0' : '#fff',
                      cursor: 'pointer',
                      display: loading ? 'none' : 'block',
                      padding: '10px 10px',
                      borderBottom: '2px solid #eee',
                    }
                    return (
                      <div key={index} {...getSuggestionItemProps(suggestion, { style })}>
                        <div style={{ display: 'inline-flex' }}>
                          <img
                            style={{ paddingRight: 10, paddingLeft: 10 }}
                            src={MapSuggestionIcon}
                          ></img>
                          <div>{suggestion.description}</div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </>
            )}
          </PlacesAutocomplete>
          <div className="map__container">
            <GoogleMapReact
              center={this.state.center}
              zoom={10}
              draggable={this.state.draggable}
              options={defaultMapOptions}
              onClick={this.handleClickElement}
              bootstrapURLKeys={{
                key: 'AIzaSyDtKbJ8frTCqg4LsSfO0GDPla_tmaO5Pmg',
                libraries: ['places', 'geometry'],
              }}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({ map, maps }) => this.apiHasLoaded(map, maps)}
            ></GoogleMapReact>
          </div>
        </>
      )
    } else {
      return <></>
    }
  }
}

export default scriptLoader(
  `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}&libraries=places&language=${win['lang']}&region=${win['lang']}`
)(Map)

// export default scriptLoader(
//   `https://maps.googleapis.com/maps/api/js?key=${win['storeGoogleMapKey']}&libraries=places&language=${win['lang']}&region=${win['lang']}`
// )(Map)
